import * as React from 'react'
import { Pie } from '@vx/shape'
import { Group } from '@vx/group'
import * as colors from 'styles/colors-export.css'
import { scaleLinear } from '@vx/scale'
import { max, min } from 'd3-array'
import { flow } from 'lodash/fp'
import { withTooltip } from '@vx/tooltip'
import { localPoint } from '@vx/event'
import { GraphTooltip } from '../GraphTooltip'
import LinedTable from 'components/Tables/LinedTable'
import { sumBy, round } from 'lodash'

export interface IGraphPieComponentProps {
  data: {
    label: string
    value: number
  }[]
  width: number
  height: number
}

const x = d => d.value

const Label = ({ x, y, children }) => {
  return (
    <text fill="white" textAnchor="middle" x={x} y={y} dy=".33em" fontSize={9}>
      {children}
    </text>
  )
}

const GraphPieComponent = ({
  width,
  height,
  data,
  margin = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  hideTooltip,
  showTooltip,
  tooltipData,
  tooltipTop,
  tooltipLeft,
}) => {
  const radius = Math.min(width, height) / 2
  const maxValue = max(data, x)
  const minValue = min(data, x)
  const opacityScale = flow(
    x,
    scaleLinear({
      range: [0.3, 1],
      domain: [minValue, maxValue],
    })
  )

  const handleTooltip = itemData => event => {
    const coords = localPoint(event.target.ownerSVGElement, event)
    showTooltip({
      tooltipLeft: coords.x,
      tooltipTop: coords.y,
      tooltipData: itemData.data,
    })
  }

  return (
    <div>
      <svg width={width} height={height}>
        <Group top={height / 2 - margin.top} left={width / 2}>
          <Pie
            data={data}
            pieValue={x}
            outerRadius={radius}
            innerRadius={radius - 80}
            fill={colors.tertiary}
            fillOpacity={opacityScale}
            cornerRadius={0}
            padAngle={0}
            centroid={(centroid, arc) => {
              const [x, y] = centroid
              const { startAngle, endAngle } = arc
              if (endAngle - startAngle < 0.1) return null
              return (
                <Label x={x} y={y}>
                  {arc.data.label}
                </Label>
              )
            }}
            onMouseOver={handleTooltip}
            onTouchStart={handleTooltip}
            onTouchMove={handleTooltip}
            onMouseMove={handleTooltip}
            onMouseLeave={data => event => hideTooltip()}
          />
        </Group>
      </svg>
      {tooltipData && (
        <GraphTooltip top={tooltipTop} left={tooltipLeft}>
          <LinedTable>
            <div>
              <div>Type:</div>
              <div>{tooltipData.label}</div>
            </div>
            <div>
              <div>Number:</div>
              <div>{tooltipData.value}</div>
            </div>
            <div>
              <div>Ratio:</div>
              <div>{round((tooltipData.value / sumBy(data, 'value')) * 100, 1)}%</div>
            </div>
          </LinedTable>
        </GraphTooltip>
      )}
    </div>
  )
}

export const GraphPie = withTooltip(GraphPieComponent)



// WEBPACK FOOTER //
// src/features/CallAnalytics/GraphPie/GraphPie.tsx